/**
 * 已下线页面：保留 src/pages 代码，但禁止访问（middleware 重定向 + 客户端守卫）。
 * 新增条目时同步更新 middleware matcher 与入口链接排查。
 *
 * 注意：/affiliate 主站未下线，可正常访问；仅 application / admin / console 子路径拦截。
 */
const DEPRECATED_ROUTE_PATTERNS = [
  /^\/academy(\/|$)/,
  /^\/listing(\/|$)/,
  /^\/finance(\/|$)/,
  /^\/launchpad(\/|$)/,
  /^\/schedule(\/|$)/,
  /^\/careers(\/|$)/,
  /^\/verify(\/|$)/,
  /^\/privacy-policy(\/|$)/,
  /^\/affiliate\/application(\/|$)/,
  /^\/affiliate\/admin(\/|$)/,
  /^\/affiliate\/console(\/|$)/,
  /^\/trade-order(\/|$)/,
];

/** 与 next.config.js i18n.locales（不含 default）一致 */
export const DEPRECATED_ROUTE_LOCALES = ["en", "zh-CN", "pt", "ar", "vi"];

/**
 * 去掉首段 i18n locale，得到用于匹配的 pathname（始终以 / 开头）
 * @param {string} pathname
 */
export function stripLocaleFromPathname(pathname) {
  const raw = (pathname || "").split("?")[0] || "/";
  if (raw === "/") return "/";

  for (const locale of DEPRECATED_ROUTE_LOCALES) {
    const prefix = `/${locale}`;
    if (raw === prefix) return "/";
    if (raw.startsWith(`${prefix}/`)) {
      const rest = raw.slice(prefix.length);
      return rest.startsWith("/") ? rest : `/${rest}`;
    }
  }

  return raw.startsWith("/") ? raw : `/${raw}`;
}

/**
 * @param {string} pathnameOrAsPath — 可含 query；可含 /en/ 等 locale 前缀
 */
export function isDeprecatedRoute(pathnameOrAsPath) {
  const path = stripLocaleFromPathname(pathnameOrAsPath);
  return DEPRECATED_ROUTE_PATTERNS.some((re) => re.test(path));
}

/**
 * 从 pathname 解析 locale；无 locale 前缀时返回 null
 * @param {string} pathname
 */
export function resolveLocaleFromPathname(pathname) {
  const raw = (pathname || "").split("?")[0] || "/";
  for (const locale of DEPRECATED_ROUTE_LOCALES) {
    const prefix = `/${locale}`;
    if (raw === prefix || raw.startsWith(`${prefix}/`)) {
      return locale;
    }
  }
  return null;
}

/** 下线页重定向目标：同 locale 首页 */
export function getDeprecatedRouteHomePath(pathnameOrAsPath, fallbackLocale) {
  const locale = resolveLocaleFromPathname(pathnameOrAsPath) || fallbackLocale;
  if (locale && locale !== "default") {
    return `/${locale}`;
  }
  return "/";
}

export { DEPRECATED_ROUTE_PATTERNS };
